export default __webpack_public_path__ + "static/media/peep-63.723ebb99.svg";